import { render, staticRenderFns } from "./activityLayOut.vue?vue&type=template&id=435c0c3e&scoped=true&"
import script from "./activityLayOut.vue?vue&type=script&lang=js&"
export * from "./activityLayOut.vue?vue&type=script&lang=js&"
import style0 from "./activityLayOut.vue?vue&type=style&index=0&id=435c0c3e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435c0c3e",
  null
  
)

export default component.exports